import { Billboard, DefaultFontManager, FrameScriptManager, MorphSprite, MovieClip, Sprite, TesselatedFontTable, TextFormat, TextFormatAlign } from '@awayjs/scene';
import { MovieClipSoundsManager } from '../factories/timelinesounds/MovieClipSoundsManager';
import { BitmapImage2D } from '@awayjs/stage';
import { MethodMaterial } from '@awayjs/materials';
import { Graphics } from '@awayjs/graphics';
import { SWFFrame } from './SWFFrame';
import { ColorUtils, Rectangle } from '@awayjs/core';
var noTimelineDebug = true;
var noExportsDebug = true;
var lazyCallbackProvider = (self['requestIdleCallback'] || self.requestAnimationFrame);
// stop run next qued task if this is runs so slow;
var MAX_TASK_TIME = 4;
var MAX_TASK_COUNT = 8;
var parserAsyncTask = [];
var rafTaskId = -1;
var processedTaskIndex = 0;
var lastRafTime = 0;
function taskLooper() {
    rafTaskId = -1;
    var time = performance.now();
    var totalTime = 0;
    var processedTask = 0;
    var skipTask = false;
    if (lastRafTime === 0) {
        skipTask = true;
        // skip task if raf is bussy
    }
    else if (time - lastRafTime > 10) {
        //skipTask = true;
        //console.log('[Lazy task runner] Thread bussy:', time - lastRafTime);
    }
    lastRafTime = time;
    while (processedTaskIndex < parserAsyncTask.length && !skipTask) {
        totalTime += executeTask();
        if (totalTime > MAX_TASK_TIME) {
            //console.debug('[Lazy task runner] Stop task by running time:', totalTime);
            break;
        }
        processedTask++;
        if (processedTask >= MAX_TASK_COUNT) {
            break;
        }
    }
    if (processedTask > 0) {
        //console.debug('[Lazy task runner] Processed tasks:', processedTask);
    }
    if (processedTaskIndex > 1) {
        parserAsyncTask.splice(0, processedTaskIndex);
        processedTaskIndex = 0;
        if (parserAsyncTask.length === 0) {
            return;
        }
    }
    rafTaskId = lazyCallbackProvider(taskLooper);
}
function executeTask() {
    var task;
    while (task && (!task.lazyParser || !task.needParse)) {
        task = parserAsyncTask[processedTaskIndex];
        processedTaskIndex++;
    }
    if (!task) {
        return 0;
    }
    var start = performance.now();
    task.lazyParser();
    task.needParse = false;
    if (task.lazyTaskDone) {
        task.lazyTaskDone(task);
    }
    return performance.now() - start;
}
function pushLazyTask(task) {
    if (!task.lazyParser || !task.needParse) {
        return;
    }
    parserAsyncTask.push(task);
    if (rafTaskId >= 0) {
        return;
    }
    rafTaskId = lazyCallbackProvider(taskLooper);
}
function matrixToStream(stream, index, matrix) {
    stream[index++] = matrix.a;
    stream[index++] = matrix.b;
    stream[index++] = matrix.c;
    stream[index++] = matrix.d;
    stream[index++] = matrix.tx / 20;
    stream[index++] = matrix.ty / 20;
    return index;
}
function colorMatrixToStream(stream, index, matrix) {
    stream[index++] = matrix.redMultiplier / 256;
    stream[index++] = matrix.greenMultiplier / 256;
    stream[index++] = matrix.blueMultiplier / 256;
    stream[index++] = matrix.alphaMultiplier / 256;
    stream[index++] = matrix.redOffset;
    stream[index++] = matrix.greenOffset;
    stream[index++] = matrix.blueOffset;
    stream[index++] = matrix.alphaOffset;
    return index;
}
var TF_ALIGNS = [
    TextFormatAlign.LEFT,
    TextFormatAlign.RIGHT,
    TextFormatAlign.CENTER,
    TextFormatAlign.JUSTIFY
];
var SymbolDecoder = /** @class */ (function () {
    function SymbolDecoder(parser) {
        this.parser = parser;
        this._awaySymbols = {};
        this._buttonIds = {};
        this._mcIds = {};
        /**
         * @description Force reqursive decoding of nested symbols, disable it when sure that symbol exist
         */
        this.reqursive = true;
    }
    Object.defineProperty(SymbolDecoder.prototype, "factory", {
        get: function () {
            return this.parser.factory;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SymbolDecoder.prototype, "awaySymbols", {
        get: function () {
            return this._awaySymbols;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * prepares framescript for use in AVM
     * this is actually only used for AVM1
     * @param source
     * @param frameIdx
     */
    SymbolDecoder.prototype.prepareFrameScriptsForAVM1 = function (source, frameIdx, objName, objID) {
        if (!this.parser.swfFile.useAVM1) {
            return source;
        }
        return this.parser.factory.createFrameScripts(source, frameIdx, objName, objID);
    };
    /**
     * Get a instance for a given SymbolID and assign a sessionID to it.
     * This is used by timeline to create children
     *
     * @param symbolID
     * @param sessionID
     */
    SymbolDecoder.prototype.createChildInstanceForTimeline = function (timeline, symbolID, sessionID) {
        // if this was called we might have new constructors from timeline to process
        FrameScriptManager.invalidAS3Constructors = true;
        var asset = this.awaySymbols[symbolID];
        var clone;
        if (asset.isAsset(Graphics)) {
            clone = Sprite.getNewSprite(asset);
            clone.mouseEnabled = false;
        }
        else if (asset.isAsset(Sprite)) {
            clone = Sprite.getNewSprite(asset.graphics);
            clone.mouseEnabled = false;
        }
        else if (asset.isAsset(MorphSprite)) {
            clone = MorphSprite.getNewMorphSprite(asset.graphics);
            clone.mouseEnabled = false;
        }
        else if (asset.isAsset(BitmapImage2D)) {
            // enable blending for symbols, because if you place image directly on stage
            // it not enable blend mode
            var m = new MethodMaterial(asset);
            m.alphaBlending = asset.transparent;
            clone = Billboard.getNewBillboard(m);
        }
        else {
            clone = asset.adapter.clone(false).adaptee;
        }
        if (this.parser.swfFile.useAVM1) {
            var placeObjectTag = timeline.placeObjectTagsForSessionIDs[sessionID];
            if (placeObjectTag
                && (placeObjectTag.variableName
                    || (placeObjectTag.events && placeObjectTag.events.length > 0))) {
                clone.adapter.placeObjectTag = placeObjectTag;
                clone.adapter.initEvents = placeObjectTag;
            }
        }
        clone._sessionID = sessionID;
        return clone;
    };
    SymbolDecoder.prototype._createShape = function (symbol, target, name) {
        var shape = new Graphics();
        /*
        if(symbol.lazyParser) {
            symbol.lazyParser();
        }*/
        pushLazyTask(symbol);
        shape.queueShapeTag(symbol);
        shape.name = name || 'AwayJS_shape_' + symbol.id.toString();
        shape.className = symbol.className;
        if (symbol.type === "morphshape" /* MORPH */) {
            return new MorphSprite(shape);
        }
        return shape;
    };
    SymbolDecoder.prototype._createFont = function (symbol, target, name) {
        symbol.away.className = symbol.className;
        if (symbol.className) {
            // hack for dynamic fonts: preregister all font-assets under classname
            DefaultFontManager.registerFontForClassName(symbol.away, symbol.className);
        }
        return symbol;
    };
    SymbolDecoder.prototype._createSprite = function (symbol, target, name) {
        noTimelineDebug || console.log('start parsing timeline: ', symbol);
        var awayMc = this.framesToTimeline(target, symbol, symbol.frames, null, null);
        if (symbol.scalingGrid)
            awayMc.scale9Grid = new Rectangle(symbol.scalingGrid.xMin / 20, symbol.scalingGrid.yMin / 20, symbol.scalingGrid.xMax / 20, symbol.scalingGrid.yMax / 20);
        awayMc.className = symbol.className;
        awayMc.name = name || 'AwayJS_mc_' + symbol.id.toString();
        if (awayMc.buttonMode) {
            this._buttonIds[symbol.id] = true;
        }
        else {
            this._mcIds[symbol.id] = true;
        }
        return awayMc;
    };
    SymbolDecoder.prototype._createText = function (symbol, target, name) {
        target = target || this.factory.createTextField(symbol);
        target._symbol = symbol;
        target.textFormat = new TextFormat();
        target.className = symbol.className;
        var flashFont = (this.reqursive ?
            this.createAwaySymbol(symbol.tag.fontId) : this._awaySymbols[symbol.tag.fontId]);
        if (flashFont) {
            target.textFormat.font = flashFont.away;
            target.textFormat.font_table = flashFont.away.get_font_table(flashFont.fontStyleName, TesselatedFontTable.assetType);
        }
        var tag = symbol.tag;
        target.textFormat.size = tag.fontHeight / 20;
        target.textColor = (tag.flags & 4 /* HasColor */) ? ColorUtils.f32_RGBA_To_f32_ARGB(tag.color) : 0xffffff;
        target.textFormat.leftMargin = tag.leftMargin / 20;
        target.textFormat.rightMargin = tag.rightMargin / 20;
        target.textFormat.letterSpacing = tag.letterSpacing / 20;
        target.textFormat.leading = tag.leading / 20;
        target.textFormat.align = TF_ALIGNS[tag.align];
        target.textOffsetX = symbol.fillBounds.xMin / 20;
        target.textOffsetY = symbol.fillBounds.yMin / 20;
        target.width = ((symbol.fillBounds.xMax - symbol.fillBounds.xMin) / 20);
        target.height = (symbol.fillBounds.yMax - symbol.fillBounds.yMin) / 20;
        target.border = !!(tag.flags & 2048 /* Border */);
        target.background = target.border;
        target.multiline = (tag.flags & 32 /* Multiline */) ? true : false;
        target.wordWrap = (tag.flags & 64 /* WordWrap */) ? true : false;
        target.selectable = tag.flags ? !(tag.flags & 4096 /* NoSelect */) : false;
        if (tag.maxLength && tag.maxLength > 0) {
            target.maxChars = tag.maxLength;
        }
        if (tag.flags & 8 /* ReadOnly */) {
            target.type = 'dynamic';
        }
        else {
            target.type = 'input';
        }
        if (tag.flags & 512 /* Html */) {
            target.html = true;
            if (tag.initialText && tag.initialText != '')
                target.htmlText = tag.initialText;
        }
        else {
            target.html = false;
            if (tag.initialText && tag.initialText != '')
                target.text = tag.initialText;
        }
        target.name = name || 'tf_' + symbol.id.toString();
        return target;
    };
    SymbolDecoder.prototype._createSound = function (symbol, target, name) {
        var awaySound = this.parser.awayUnresolvedSymbols[symbol.id];
        if (awaySound) {
            awaySound.className = this.parser.symbolClassesMap[symbol.id] || null;
            awaySound.name = awaySound.className;
            //awaySound.play(0,false);
        }
        else {
            console.warn('SWF-parser: no sound loaded for sound-id:', symbol.id);
        }
        return awaySound;
    };
    SymbolDecoder.prototype._createButton = function (symbol, target, name) {
        noTimelineDebug || console.log('start parsing button: ', symbol);
        target = this.framesToTimeline(target, symbol, null, symbol.states, symbol.buttonActions, symbol.buttonSounds);
        //awayMc._symbol=symbol;
        target.name = name || 'AwayJS_button_' + symbol.id.toString();
        target.className = symbol.className;
        this._buttonIds[symbol.id] = true;
        return target;
        /*
        assetsToFinalize[dictionary[i].id] = awayMc;
        this._awaySymbols[dictionary[i].id] = awayMc;
        */
        /*
        var mySprite:SimpleButton=new SimpleButton();
        console.log("Button:", symbol);
        //var awayMc = this.framesToAwayTimeline(symbol.frames);
        //mySprite._symbol=symbol;
        this._pFinalizeAsset(mySprite, symbol.id);
        this._awaySymbols[dictionary[i].id] = mySprite;
        */
    };
    SymbolDecoder.prototype._createLabel = function (symbol, target, name) {
        target = target || this.factory.createTextField(symbol);
        var font = null;
        var fontExist = false;
        target.className = symbol.className;
        for (var r = 0; r < symbol.records.length; r++) {
            var record = symbol.records[r];
            if (record.fontId) {
                font = this.reqursive ?
                    this.createAwaySymbol(record.fontId) : this._awaySymbols[record.fontId];
                if (font) {
                    //awayText.textFormat.font=font.away;
                    record.font = font;
                    record.font_table = font.away.get_font_table(font.fontStyleName, TesselatedFontTable.assetType);
                    if (!record.font_table) {
                        fontExist = true;
                        console.log('no font_table set');
                    }
                    //record.font_table=font.away.font_styles[0];
                }
            }
        }
        target.staticMatrix = symbol.matrix;
        target.textOffsetX = symbol.fillBounds.xMin / 20;
        target.textOffsetY = symbol.fillBounds.yMin / 20;
        target.width = (symbol.fillBounds.xMax / 20 - symbol.fillBounds.xMin / 20) - 1;
        target.height = (symbol.fillBounds.yMax / 20 - symbol.fillBounds.yMin / 20) - 1;
        if (!fontExist) {
            target.setLabelData(symbol);
        }
        target.name = name || 'AwayJS_label_' + symbol.id.toString();
        /*
        assetsToFinalize[dictionary[i].id] = target;
        this._awaySymbols[dictionary[i].id] = target;
    */
        target.selectable = (symbol.tag.flags && !(symbol.tag.flags & 4096 /* NoSelect */));
        return target;
    };
    SymbolDecoder.prototype._createImage = function (symbol, target, name) {
        var useLazy = true;
        target = target || this.parser.awayUnresolvedSymbols[symbol.id];
        if (!target && symbol.definition) {
            var def = symbol.definition;
            target = new BitmapImage2D(def.width, def.height, true, null, false);
            target.addLazySymbol(symbol);
            if (!useLazy) {
                target.applySymbol();
            }
            /*
            if (def.data.length != (4 * def.width * def.height)
                && def.data.length != (3 * def.width * def.height))
            {
                def.data = new Uint8ClampedArray(4 * def.width * def.height);
                //symbol.definition.data.fill
            }
            target.setPixels(new Rectangle(0, 0, def.width, def.height), def.data);
            */
        }
        if (target) {
            target.className = this.parser.symbolClassesMap[symbol.id] ?
                this.parser.symbolClassesMap[symbol.id] : symbol.className;
            target.name = target.className;
            //assetsToFinalize[dictionary[i].id] = target;
        }
        return target;
    };
    SymbolDecoder.prototype._createBinary = function (symbol, target, name) {
        if (this.factory.createBinarySymbol)
            this.factory.createBinarySymbol(symbol);
        /*
        const bin = new ByteArray(bs.byteLength);
        const asset = new GenericAsset<ByteArray>(bin, bs.className, ByteArray);
        bin.setArrayBuffer(bs.data.buffer);
        */
        return null;
    };
    SymbolDecoder.prototype._createVideo = function (symbol, target, name) {
        var dummyVideo = new BitmapImage2D(symbol.width, symbol.height, false, 0x00ff00, false);
        dummyVideo._symbol = symbol;
        dummyVideo.className = this.parser.symbolClassesMap[symbol.id] ?
            this.parser.symbolClassesMap[symbol.id] : symbol.className;
        dummyVideo.name = dummyVideo.className;
        return dummyVideo;
    };
    SymbolDecoder.prototype.createAwaySymbol = function (symbol, target, name) {
        if (typeof symbol === 'number') {
            // Return existed away symbol by ID, skip getSymbol
            if (!target && this._awaySymbols[symbol]) {
                return this._awaySymbols[symbol];
            }
            symbol = this.parser.getSymbol(symbol);
        }
        if (!symbol) {
            throw new Error('Symbol can\'t be null');
        }
        //name = symbol.className;
        // return existed away symbol by ID inside symbol
        if (!target && this._awaySymbols[symbol.id]) {
            return this._awaySymbols[symbol.id];
        }
        var asset;
        //Stat.rec("parser").rec("symbols").rec("away").begin();
        //symbol.className && console.log(symbol.type, symbol.className);
        switch (symbol.type) {
            case "morphshape" /* MORPH */:
                {
                    asset = this._createShape(symbol, target, name || 'AwayJS_morphshape_' + symbol.id.toString());
                    break;
                }
            case "shape" /* SHAPE */:
                {
                    asset = this._createShape(symbol, target, name);
                    break;
                }
            case "font" /* FONT */:
                {
                    asset = this._createFont(symbol, target, name);
                    break;
                }
            case "sprite" /* SPRITE */:
                {
                    asset = this._createSprite(symbol, target, name);
                    break;
                }
            case "text" /* TEXT */:
                {
                    asset = this._createText(symbol, target, name);
                    break;
                }
            case "sound" /* SOUND */:
                {
                    asset = this._createSound(symbol, target, name);
                    break;
                }
            case "button" /* BUTTON */:
                {
                    asset = this._createButton(symbol, target, name);
                    break;
                }
            case "label" /* LABEL */:
                {
                    asset = this._createLabel(symbol, target, name);
                    break;
                }
            case "image" /* IMAGE */:
                {
                    asset = this._createImage(symbol, target, name);
                    break;
                }
            case "binary" /* BINARY */:
                {
                    asset = this._createBinary(symbol, target, name);
                    break;
                }
            case "video" /* VIDEO */:
                {
                    asset = this._createVideo(symbol, target, name);
                    break;
                }
            default:
                throw Error('Unknown symbol type:' + symbol.type);
        }
        this._awaySymbols[symbol.id] = asset;
        this.parser.registerAwayAsset(asset, symbol);
        return asset;
    };
    SymbolDecoder.prototype.framesToTimeline = function (awayMc, symbol, swfFrames, states, buttonActions, buttonSound) {
        var _this = this;
        if (buttonSound === void 0) { buttonSound = null; }
        if (!states && !swfFrames) {
            throw ('error when creating timeline - neither movieclip frames nor button-states present');
        }
        var getSymbol = this.reqursive ?
            function (id) { return (_this._awaySymbols[id] || _this.createAwaySymbol(id)); } :
            function (id) { return _this._awaySymbols[id]; };
        //console.log("swfFrames", swfFrames);
        var isButton = false;
        var key;
        symbol.isButton = false;
        if (states && !swfFrames) {
            isButton = true;
            symbol.isButton = true;
            swfFrames = [];
            for (key in states) {
                var newSWFFrame = new SWFFrame();
                newSWFFrame.controlTags = states[key];
                newSWFFrame.buttonStateName = key;
                swfFrames[swfFrames.length] = newSWFFrame;
                //console.log("buttonSound ", buttonSound);
            }
        }
        awayMc = awayMc || this.factory.createMovieClip(null, symbol);
        awayMc.symbolID = symbol.id;
        var sessionIDCount = 0;
        var awayTimeline = awayMc.timeline;
        awayMc.timeline.symbolDecoder = this;
        var keyframe_durations = [];
        var frameCmdInd = [];
        var frameRecipe = [];
        var cmdStreamLength = [];
        var cmdStremInd = [];
        var addChildStream = [];
        var addSoundsStream = [];
        /**
         * @description Remove Child Stream
         */
        var remChildStream = [];
        /**
         * @description Update Child Stream
         */
        var updChildStream = [];
        /**
         * @description Update Child Stream: Property Index
         */
        var updСhildStreamPropsInd = [];
        /**
         * @description Update Child Stream: Property Lenght
         */
        var updChildStreamPropsLen = [];
        var propStreamType = [];
        var propStreamIndex = [];
        var propStreamInt = [];
        var propStreamFilters = [];
        /**
         * @description Matrix: Scale + Rotation props,
         * @type {Float32Array}
         */
        var propStramMatrixSR = [];
        /**
         * @description Matrix: Position props,
         * @type {Float32Array}
         */
        var propStreamMatrixPos = [];
        var propStreamMatrixAll = [];
        var propStreamCT = [];
        var propStreamStr = [];
        var virtualScenegraph = {};
        var keyFrameCount = 0;
        var cmds_removed = [];
        var cmds_add = [];
        var cmds_update = [];
        var cmds_startSounds = [];
        var cmds_stopSounds = [];
        var unparsedTags = [];
        var transformsAtDepth = {};
        var instanceCNT = 0;
        var child;
        var i;
        var framesLen = swfFrames.length;
        var command_recipe_flag = 0;
        var audio_commands_cnt = 0;
        var labelName;
        var fl;
        var fl_len;
        var isEmpty;
        var len;
        var ct;
        var unparsedTag;
        var placeObjectTag;
        var hasCharacter;
        var awaySymbol = null;
        var sessionID = -1;
        var swapGraphicsID = -1;
        var ratio = -1;
        var flashSymbol;
        var graphicsSprite;
        var doAdd = true;
        var tag;
        MovieClip.movieClipSoundsManagerClass = MovieClipSoundsManager;
        for (i = 0; i < framesLen; i++) {
            noTimelineDebug || console.log('	process frame:', i + 1, '/', framesLen);
            cmds_removed.length = 0;
            cmds_add.length = 0;
            cmds_update.length = 0;
            cmds_startSounds.length = 0;
            cmds_stopSounds.length = 0;
            unparsedTags.length = 0;
            if (swfFrames[i].soundStreamHead) {
                awayMc.initSoundStream(swfFrames[i].soundStreamHead, framesLen);
                //console.log("stream encountered", swfFrames[i].soundStreamHead)
            }
            if (swfFrames[i].soundStreamBlock) {
                awayMc.addSoundStreamBlock(i, swfFrames[i].soundStreamBlock);
                //console.log("stream encountered", swfFrames[i].soundStreamHead)
            }
            if (swfFrames[i].initActionBlocks) {
                awayTimeline.avm1InitActions[i] = swfFrames[i].initActionBlocks;
            }
            if (swfFrames[i].exports) {
                awayTimeline.avm1Exports[i] = swfFrames[i].exports;
                for (key in swfFrames[i].exports) {
                    //console.log("\n\nfound export\n\n", swfFrames[i].exports[key]);
                    var asset = swfFrames[i].exports[key];
                    var awayAsset = getSymbol(asset.symbolId);
                    if (!awayAsset) {
                        console.log('\n\nerror: no away-asset for export\n\n', swfFrames[i].exports[key]);
                    }
                    else {
                        if (awayAsset.isAsset) {
                            // this is a awayjs asset. we just update its name.
                            // all awayjs-assets will get registered on AssetLibrary
                            // by name at very end of parseSymbolsToAwayJS function
                            awayAsset.name = asset.className.toLowerCase();
                        }
                        else {
                            // this is a binary asset.
                            // should already be handled in AXSecurityDomain.createInitializerFunction
                        }
                    }
                    noExportsDebug || console.log('			added export', swfFrames[i].exports[key], asset.className, asset.symbolId, awayAsset);
                }
            }
            // check if this is a empty frame
            isEmpty = ((!swfFrames[i].controlTags || swfFrames[i].controlTags.length == 0) &&
                (!swfFrames[i].labelNames || swfFrames[i].labelNames.length == 0) &&
                (!swfFrames[i].actionBlocks || swfFrames[i].actionBlocks.length == 0));
            noTimelineDebug || console.log('	process frame:', i + 1, '/', isEmpty, swfFrames[i]);
            if ((keyframe_durations.length != 0) && isEmpty) {
                // frame is empty and it is not the first frame
                // we just add to the duration of the last keyframe
                if (isButton) {
                    command_recipe_flag = 0;
                    command_recipe_flag |= 0x01;
                    frameCmdInd.push(cmdStremInd.length);
                    keyframe_durations[keyframe_durations.length] = 1;
                    frameRecipe.push(command_recipe_flag);
                    for (key in virtualScenegraph) {
                        child = virtualScenegraph[key];
                    }
                    virtualScenegraph = {};
                    keyFrameCount++;
                    //transformsAtDepth[tag.depth.toString()]=null;
                    noTimelineDebug || console.log('			remove all to  create empty button frame');
                }
                else {
                    noTimelineDebug || console.log('			extending last frames duration');
                    keyframe_durations[keyframe_durations.length - 1] += 1;
                }
            }
            else {
                // frame is not empty, or it is the first frame, or both
                command_recipe_flag = 0;
                if (isButton) {
                    command_recipe_flag |= 0x01;
                    for (key in virtualScenegraph) {
                        child = virtualScenegraph[key];
                    }
                    virtualScenegraph = {};
                }
                frameCmdInd.push(cmdStremInd.length);
                keyframe_durations[keyframe_durations.length] = 1;
                if (!isEmpty && (swfFrames[i].labelNames && swfFrames[i].labelNames.length > 0)) {
                    fl_len = swfFrames[i].labelNames.length;
                    for (fl = 0; fl < fl_len; fl++) {
                        labelName = swfFrames[i].labelNames[fl];
                        var originalLabelName = labelName;
                        if (this.parser.swfFile.useAVM1) {
                            labelName = labelName.toLowerCase();
                        }
                        if (!awayTimeline._labels[labelName])
                            awayTimeline._labels[labelName] = {
                                keyFrameIndex: keyFrameCount,
                                name: originalLabelName
                            };
                    }
                }
                if (!isEmpty && swfFrames[i].actionBlocks && swfFrames[i].actionBlocks.length > 0) {
                    awayTimeline.add_framescript(swfFrames[i].actionBlocks, i, awayMc, true);
                }
                if (buttonSound && buttonSound[keyFrameCount] && buttonSound[keyFrameCount].id != 0) {
                    awaySymbol = getSymbol(buttonSound[keyFrameCount].id);
                    if (awaySymbol) {
                        awayTimeline.audioPool[audio_commands_cnt] = {
                            cmd: 15 /* CODE_START_SOUND */,
                            id: buttonSound[keyFrameCount].id,
                            sound: awaySymbol,
                            props: buttonSound[keyFrameCount].info
                        };
                        cmds_startSounds.push(audio_commands_cnt++);
                    }
                }
                keyFrameCount++;
                if (!isEmpty && swfFrames[i].controlTags && swfFrames[i].controlTags.length > 0) {
                    noTimelineDebug || console.log('			Start parsing controltags', swfFrames[i].controlTags.length);
                    len = swfFrames[i].controlTags.length;
                    for (ct = 0; ct < len; ct++) {
                        unparsedTag = swfFrames[i].controlTags[ct];
                        tag = unparsedTag.tagCode === undefined ?
                            unparsedTag : this.parser.getParsedTag(unparsedTag);
                        //console.log("parsed tag", tag);
                        switch (tag.code) {
                            case 15 /* CODE_START_SOUND */:
                                //console.log("CODE_START_SOUND", tag)
                                awaySymbol = getSymbol(tag.soundId);
                                if (tag.soundInfo && (tag.soundInfo.flags & 32 /* Stop */)) {
                                    awayTimeline.audioPool[audio_commands_cnt] = {
                                        cmd: 16 /* CODE_STOP_SOUND */,
                                        id: tag.soundId,
                                        sound: getSymbol(tag.soundId),
                                        props: tag.soundInfo
                                    };
                                    noTimelineDebug || console.log('stopsound', tag.soundId, tag.soundInfo, i + 1);
                                }
                                else {
                                    awayTimeline.audioPool[audio_commands_cnt] = {
                                        cmd: 15 /* CODE_START_SOUND */,
                                        id: tag.soundId,
                                        sound: getSymbol(tag.soundId),
                                        props: tag.soundInfo
                                    };
                                    noTimelineDebug || console.log('startsound', tag.soundId, tag.soundInfo, awaySymbol, i + 1);
                                }
                                // todo: volume / pan / other properties
                                cmds_startSounds.push(audio_commands_cnt++);
                                break;
                            case 16 /* CODE_STOP_SOUND */:
                                //console.log("CODE_STOP_SOUND", tag)
                                // todo
                                //console.log("stopsound", tag.soundId, tag.soundInfo);
                                awayTimeline.audioPool[audio_commands_cnt] = {
                                    cmd: 16 /* CODE_STOP_SOUND */,
                                    id: tag.soundId,
                                    sound: getSymbol(tag.soundId),
                                    props: tag.soundInfo
                                };
                                noTimelineDebug || console.log('stopsound', tag.soundId, tag.soundInfo, i + 1);
                                cmds_startSounds.push(audio_commands_cnt++);
                                break;
                            case 5 /* CODE_REMOVE_OBJECT */:
                            case 28 /* CODE_REMOVE_OBJECT2 */:
                                child = virtualScenegraph[tag.depth];
                                if (!child) {
                                    console.log('Error in timeline. remove cant find the object to remove');
                                }
                                if (this.parser.swfFile.useAVM1)
                                    cmds_removed[cmds_removed.length] = { depth: tag.depth | 0 };
                                else
                                    cmds_removed[cmds_removed.length] = { depth: child.sessionID | 0 };
                                virtualScenegraph[tag.depth] = null;
                                transformsAtDepth[tag.depth.toString()] = null;
                                delete virtualScenegraph[tag.depth];
                                noTimelineDebug || console.log('				remove', 'depth', tag.depth);
                                break;
                            case 4 /* CODE_PLACE_OBJECT */:
                            case 26 /* CODE_PLACE_OBJECT2 */:
                            case 70 /* CODE_PLACE_OBJECT3 */:
                                placeObjectTag = tag;
                                //console.log("CODE_PLACE_OBJECT", tag.depth | 0, placeObjectTag);
                                child = virtualScenegraph[tag.depth];
                                hasCharacter = placeObjectTag.symbolId > -1;
                                // Check for invalid flag constellations.
                                if (placeObjectTag.flags & 1 /* Move */) {
                                    // Invalid case 1: Move flag set but no child found at given depth.
                                    if (!child) {
                                        //  Ignore the current tag.
                                        break;
                                    }
                                }
                                awaySymbol = null;
                                sessionID = -1;
                                swapGraphicsID = -1;
                                ratio = -1;
                                // possible options:
                                // hasCharacter && !child
                                //		we need to put a child into the display list.
                                //		might need to create sprite for graphics !
                                // hasCharacter && child
                                //		need to update a child with a new graphic
                                //		if the existing child is not a graphic, we need to remove it
                                //		and add a new sprite for it, so we can update the graphics there
                                // !hasCharacter && child
                                //		need to update a child
                                // !hasCharacter && !child
                                //		something is wrong ?
                                if (hasCharacter) {
                                    //console.log("placeTag symbol id",placeObjectTag.symbolId )
                                    awaySymbol = getSymbol(placeObjectTag.symbolId);
                                    if (!awaySymbol) {
                                        console.warn('Symbol missed:', placeObjectTag.symbolId);
                                        break;
                                    }
                                    flashSymbol = this.parser.dictionary[placeObjectTag.symbolId];
                                    //addedIds[addedIds.length]=placeObjectTag.symbolId;
                                    if (awaySymbol.isAsset(Graphics)) {
                                        swapGraphicsID = placeObjectTag.symbolId;
                                        if (!awayTimeline.graphicsPool[placeObjectTag.symbolId]) {
                                            awayTimeline.graphicsPool[placeObjectTag.symbolId] = awaySymbol;
                                        }
                                        // register a new instance for this object
                                        graphicsSprite = this.factory.createSprite(null, awaySymbol, flashSymbol);
                                        graphicsSprite.mouseEnabled = false;
                                        // if this a child is already existing, and it is a sprite,
                                        // we will just use the swapGraphics command to exchange the graphics it holds
                                        if (child && child.awayChild.isAsset(Sprite)) {
                                            sessionID = child.sessionID;
                                            // a child (sprite) already exists
                                            // the swapGraphicsId will be handled in the update command
                                        }
                                        else {
                                            if (placeObjectTag != null
                                                && ((placeObjectTag.name && placeObjectTag.name != '')
                                                    || this._mcIds[placeObjectTag.symbolId]
                                                    || this._buttonIds[placeObjectTag.symbolId])) {
                                                if (!placeObjectTag.name || placeObjectTag.name == '')
                                                    placeObjectTag.name = 'instance' +
                                                        placeObjectTag.symbolId + '_' + instanceCNT++;
                                            }
                                            if (child) {
                                                if (this.parser.swfFile.useAVM1)
                                                    cmds_removed[cmds_removed.length] = { depth: tag.depth | 0 };
                                                else
                                                    cmds_removed[cmds_removed.length] = { depth: child.sessionID | 0 };
                                                virtualScenegraph[tag.depth] = null;
                                                transformsAtDepth[tag.depth.toString()] = null;
                                                delete virtualScenegraph[tag.depth];
                                                noTimelineDebug || console.log('	remove because we want to add a shape at this depth', 'depth', tag.depth);
                                            }
                                            sessionID = sessionIDCount++;
                                            if (placeObjectTag.name
                                                || placeObjectTag.variableName
                                                || (placeObjectTag.events && placeObjectTag.events.length > 0)) {
                                                awayTimeline.placeObjectTagsForSessionIDs[sessionID] = placeObjectTag;
                                            }
                                            noTimelineDebug || console.log('				add shape', 'session-id', sessionID, 'depth', tag.depth, tag, awaySymbol);
                                            child = virtualScenegraph[tag.depth] = {
                                                sessionID: sessionID,
                                                id: placeObjectTag.symbolId,
                                                masks: [],
                                                isMask: false,
                                                clipDepth: 0,
                                                depth: 0,
                                                awayChild: graphicsSprite,
                                                name: placeObjectTag.name ? placeObjectTag.name : 'noname'
                                            };
                                            cmds_add[cmds_add.length] = {
                                                sessionID: sessionID,
                                                depth: tag.depth,
                                                id: placeObjectTag.symbolId,
                                                name: placeObjectTag.name
                                            };
                                        }
                                    }
                                    else {
                                        if (!placeObjectTag.name || placeObjectTag.name == '')
                                            placeObjectTag.name = 'instance'
                                                + placeObjectTag.symbolId + '_' + instanceCNT++;
                                        sessionID = sessionIDCount++;
                                        if (placeObjectTag.name
                                            || placeObjectTag.variableName
                                            || (placeObjectTag.events && placeObjectTag.events.length > 0)) {
                                            awayTimeline.placeObjectTagsForSessionIDs[sessionID] = placeObjectTag;
                                        }
                                        doAdd = true;
                                        if (virtualScenegraph[tag.depth]
                                            && virtualScenegraph[tag.depth].id == placeObjectTag.symbolId) {
                                            doAdd = false;
                                        }
                                        else if (virtualScenegraph[tag.depth]) {
                                            // if depth is occupied remove existing child
                                            if (this.parser.swfFile.useAVM1)
                                                cmds_removed[cmds_removed.length] = { depth: tag.depth | 0 };
                                            else
                                                cmds_removed[cmds_removed.length] = {
                                                    depth: virtualScenegraph[tag.depth].sessionID | 0
                                                };
                                        }
                                        child = virtualScenegraph[tag.depth] = {
                                            sessionID: sessionID,
                                            id: placeObjectTag.symbolId,
                                            masks: [],
                                            isMask: false,
                                            clipDepth: 0,
                                            depth: 0,
                                            awayChild: awaySymbol,
                                            name: placeObjectTag.name ? placeObjectTag.name : 'noname'
                                        };
                                        if (doAdd) {
                                            noTimelineDebug || console.log('				add', 'session-id', sessionID, 'depth', tag.depth, tag, awaySymbol);
                                            cmds_add[cmds_add.length] = {
                                                sessionID: sessionID,
                                                depth: tag.depth,
                                                id: placeObjectTag.symbolId,
                                                name: placeObjectTag.name
                                            };
                                        }
                                    }
                                }
                                if (placeObjectTag.flags & 16 /* HasRatio */) {
                                    if (!awaySymbol)
                                        awaySymbol = getSymbol(child.id);
                                    if (awaySymbol.isAsset(MorphSprite))
                                        ratio = placeObjectTag.ratio;
                                }
                                if (child) {
                                    cmds_update[cmds_update.length] = {
                                        child: child, placeObjectTag: placeObjectTag,
                                        swapGraphicsID: swapGraphicsID,
                                        ratio: ratio, depth: tag.depth
                                    };
                                    noTimelineDebug || console.log('				update', 'session-id', child.sessionID, 'hasCharacter', hasCharacter, 'depth', tag.depth, 'swapGraphicsID', swapGraphicsID, tag, awaySymbol);
                                }
                                else {
                                    throw ('error in add command');
                                }
                                break;
                            default:
                                console.log('unknown timeline command tag', tag);
                        }
                        //console.log("parsed a tag: ", tag);
                    }
                    // create remove commands:
                    var start_index = remChildStream.length;
                    var command_cnt = cmds_removed.length;
                    if (command_cnt) {
                        start_index = remChildStream.length;
                        for (var cmd = 0; cmd < command_cnt; cmd++) {
                            remChildStream.push(cmds_removed[cmd].depth);
                        }
                        command_recipe_flag |= 0x02;
                        cmdStreamLength.push(remChildStream.length - start_index);
                        cmdStremInd.push(start_index);
                        if (!noTimelineDebug) {
                            for (var iDebug = 0; iDebug < cmds_removed.length; iDebug++) {
                                console.log('				removeCmd', cmds_removed[iDebug]);
                            }
                        }
                    }
                    // create add commands:
                    command_cnt = cmds_add.length;
                    if (command_cnt) {
                        start_index = addChildStream.length;
                        for (var cmd = 0; cmd < command_cnt; cmd++) {
                            addChildStream.push(cmds_add[cmd].sessionID);
                            addChildStream.push(cmds_add[cmd].depth);
                            addChildStream.push(cmds_add[cmd].id);
                        }
                        command_recipe_flag |= 0x04;
                        cmdStreamLength.push(command_cnt);
                        cmdStremInd.push(start_index / 3);
                        if (!noTimelineDebug) {
                            for (var iDebug = 0; iDebug < cmds_add.length; iDebug++) {
                                console.log('				addCommands', cmds_add[iDebug]);
                            }
                        }
                    }
                    // create update commands:
                    command_cnt = cmds_update.length;
                    // virtualScenegraph is already updated.
                    // making sure all childs update their masking if needed:
                    for (key in virtualScenegraph) {
                        virtualScenegraph[key].oldMasks = virtualScenegraph[key].masks;
                        virtualScenegraph[key].masks = [];
                        virtualScenegraph[key].maskingChanged = false;
                    }
                    // for newly added objects, we translate the clipDepth to isMask
                    if (command_cnt) {
                        for (var cmd = 0; cmd < command_cnt; cmd++) {
                            placeObjectTag = cmds_update[cmd].placeObjectTag;
                            child = cmds_update[cmd].child;
                            child.maskingChanged = true;
                            if (placeObjectTag.flags & 64 /* HasClipDepth */) {
                                virtualScenegraph[placeObjectTag.depth].isMask = true;
                                virtualScenegraph[placeObjectTag.depth].clipDepth = placeObjectTag.clipDepth - 1;
                                virtualScenegraph[placeObjectTag.depth].depth = placeObjectTag.depth;
                            }
                        }
                    }
                    // now we are sure all scenegraphobjects know if they are a mask.
                    // we loop over all of them and apply the masking to the maskee
                    for (key in virtualScenegraph) {
                        if (virtualScenegraph[key].isMask) {
                            var depth = virtualScenegraph[key].clipDepth;
                            while (depth > virtualScenegraph[key].depth) {
                                if (virtualScenegraph[depth])
                                    virtualScenegraph[depth].masks.push(virtualScenegraph[key].sessionID);
                                depth--;
                            }
                        }
                    }
                    var m = 0;
                    var mLen = 0;
                    var childsWithMaskChanges = [];
                    // check for what objects the masking has been changed in this frame
                    for (key in virtualScenegraph) {
                        var myChild = virtualScenegraph[key];
                        myChild.masks.sort();
                        myChild.oldMasks.sort();
                        if (myChild.masks.length != myChild.oldMasks.length) {
                            childsWithMaskChanges.push(myChild);
                            myChild.maskingChanged = true;
                        }
                        else {
                            m = 0;
                            mLen = myChild.masks.length;
                            for (m = 0; m < mLen; m++) {
                                if (myChild.masks[m] != myChild.oldMasks[m]) {
                                    childsWithMaskChanges.push(myChild);
                                    myChild.maskingChanged = true;
                                    break;
                                }
                            }
                        }
                    }
                    mLen = childsWithMaskChanges.length;
                    for (m = 0; m < mLen; m++) {
                        var hasCmd = false;
                        if (command_cnt) {
                            for (var cmd = 0; cmd < command_cnt; cmd++) {
                                if (cmds_update[cmd].child == childsWithMaskChanges[m]) {
                                    hasCmd = true;
                                }
                            }
                        }
                        if (!hasCmd) {
                            cmds_update[cmds_update.length] = {
                                child: childsWithMaskChanges[m],
                                placeObjectTag: null,
                                swapGraphicsID: null,
                                ratio: null, depth: null
                            };
                        }
                    }
                    command_cnt = cmds_update.length;
                    if (command_cnt) {
                        // process updated props
                        if (!noTimelineDebug) {
                            for (var iDebug = 0; iDebug < cmds_update.length; iDebug++) {
                                console.log('				cmds_update', cmds_update[iDebug]);
                            }
                        }
                        start_index = updChildStream.length;
                        var updateCnt = 0;
                        for (var cmd = 0; cmd < command_cnt; cmd++) {
                            var updateCmd = cmds_update[cmd];
                            placeObjectTag = updateCmd.placeObjectTag;
                            child = updateCmd.child;
                            var childStartIdx = propStreamType.length;
                            var num_updated_props = 0;
                            if ((updateCmd.swapGraphicsID != null && updateCmd.swapGraphicsID >= 0)) {
                                num_updated_props++;
                                propStreamType.push(202 /* SWAP_GRAPHICS */);
                                propStreamIndex.push(propStreamInt.length);
                                propStreamInt.push(updateCmd.swapGraphicsID);
                            }
                            var isButtonOrMc = placeObjectTag
                                && (this._buttonIds[placeObjectTag.symbolId] || this._mcIds[placeObjectTag.symbolId]);
                            if (placeObjectTag
                                && ((placeObjectTag.name && placeObjectTag.name != '')
                                    || isButtonOrMc)) {
                                num_updated_props++;
                                if (this._buttonIds[placeObjectTag.symbolId]) {
                                    propStreamType.push(5 /* UPDATE_BUTTON_NAME */);
                                }
                                else {
                                    propStreamType.push(4 /* UPDATE_NAME */);
                                }
                                propStreamIndex.push(propStreamStr.length);
                                propStreamStr.push(placeObjectTag.name);
                            }
                            if (placeObjectTag != null && placeObjectTag.flags & 4 /* HasMatrix */) {
                                num_updated_props++;
                                //matrix type: 1=all, 11=no position, 12=no scale
                                propStreamType.push(1 /* UPDATE_MTX */);
                                propStreamIndex.push(propStreamMatrixAll.length / 6);
                                // todo: we can save memory by checking if only scale or position was changed,
                                // but it means we would need to check against the matrix
                                // of the current child, not against identy matrix
                                // there seem to a some transforms coming in with scale=0 when it should be scale=1
                                // This is a flash-bug (?) todo with sharing graphics across multiple mc
                                // if we set a object to scale=0 on purpose in Flash, we still get a scale>0 in swf,
                                // so looks like we can fix this by making sure that scale=0 is converted to scale = 1
                                if (placeObjectTag.matrix.a == 0
                                    && placeObjectTag.matrix.b == 0
                                    && placeObjectTag.matrix.c == 0
                                    && placeObjectTag.matrix.d != 0) {
                                    placeObjectTag.matrix.a = 1;
                                }
                                else if (placeObjectTag.matrix.d == 0
                                    && placeObjectTag.matrix.b == 0
                                    && placeObjectTag.matrix.c == 0
                                    && placeObjectTag.matrix.a != 0) {
                                    placeObjectTag.matrix.d = 1;
                                }
                                matrixToStream(propStreamMatrixAll, propStreamMatrixAll.length, placeObjectTag.matrix);
                                transformsAtDepth[updateCmd.depth.toString()] = placeObjectTag.matrix;
                            }
                            else if (updateCmd.depth != null) {
                                var exTransform = transformsAtDepth[updateCmd.depth.toString()];
                                if (exTransform) {
                                    num_updated_props++;
                                    //matrix type: 1=all, 11=no position, 12=no scale
                                    propStreamType.push(1 /* UPDATE_MTX */);
                                    propStreamIndex.push(propStreamMatrixAll.length / 6);
                                    matrixToStream(propStreamMatrixAll, propStreamMatrixAll.length, exTransform);
                                }
                            }
                            if (placeObjectTag != null && placeObjectTag.flags & 8 /* HasColorTransform */) {
                                //console.log("PlaceObjectFlags.HasColorTransform", placeObjectTag.cxform);
                                propStreamType.push(2 /* UPDATE_CMTX */);
                                propStreamIndex.push(propStreamCT.length / 8);
                                num_updated_props++;
                                colorMatrixToStream(propStreamCT, propStreamCT.length, placeObjectTag.cxform);
                            }
                            if (updateCmd.ratio != null && updateCmd.ratio >= 0) {
                                num_updated_props++;
                                propStreamType.push(203 /* SET_RATIO */);
                                propStreamIndex.push(propStreamInt.length);
                                propStreamInt.push(updateCmd.ratio | 0);
                                //console.log("PlaceObjectFlags.HasRatio", placeObjectTag, child);
                            }
                            if (child.maskingChanged) {
                                num_updated_props++;
                                propStreamType.push(3 /* UPDATE_MASKS */);
                                propStreamIndex.push(propStreamInt.length);
                                propStreamInt.push(child.masks.length);
                                for (var _i = 0, _a = child.masks; _i < _a.length; _i++) {
                                    var val = _a[_i];
                                    propStreamInt.push(val);
                                }
                            }
                            if (placeObjectTag != null && placeObjectTag.flags & 64 /* HasClipDepth */) {
                                num_updated_props++;
                                propStreamType.push(200 /* ENABLE_MASKMODE */);
                                propStreamIndex.push(0);
                            }
                            if (placeObjectTag != null && placeObjectTag.flags & 256 /* HasFilterList */) {
                                //console.log("encountered filters", placeObjectTag.filters);
                                num_updated_props++;
                                propStreamType.push(9 /* UPDATE_FILTERS */);
                                propStreamIndex.push(propStreamInt.length);
                                propStreamInt.push(propStreamFilters.length);
                                propStreamInt.push(placeObjectTag.filters.length);
                                for (var f = 0; f < placeObjectTag.filters.length; f++)
                                    propStreamFilters.push(placeObjectTag.filters[f]);
                            }
                            if (placeObjectTag != null && placeObjectTag.flags & 8192 /* HasVisible */) {
                                num_updated_props++;
                                propStreamType.push(6 /* UPDATE_VISIBLE */);
                                propStreamIndex.push(placeObjectTag.visibility ? 1 : 0);
                            }
                            if (placeObjectTag != null && placeObjectTag.flags & 512 /* HasBlendMode */) {
                                num_updated_props++;
                                propStreamType.push(7 /* UPDATE_BLENDMODE */);
                                propStreamIndex.push(placeObjectTag.blendMode);
                            }
                            if (num_updated_props > 0) {
                                updateCnt++;
                                updChildStream.push(child.sessionID);
                                updСhildStreamPropsInd.push(childStartIdx);
                                updChildStreamPropsLen.push(num_updated_props);
                            }
                        }
                        if (updateCnt > 0) {
                            command_recipe_flag |= 0x08;
                            cmdStreamLength.push(command_cnt);
                            cmdStremInd.push(start_index);
                        }
                    }
                    command_cnt = cmds_startSounds.length;
                    if (command_cnt) {
                        command_recipe_flag |= 16;
                        start_index = addSoundsStream.length;
                        //console.log("startsound", tag.soundId, tag.soundInfo, awaySymbol);
                        for (var cmd = 0; cmd < command_cnt; cmd++) {
                            addSoundsStream.push(cmds_startSounds[cmd]);
                            //console.log("add", cmds_add[cmd].childID , cmds_add[cmd].depth);
                        }
                        cmdStreamLength.push(command_cnt);
                        cmdStremInd.push(start_index);
                        noTimelineDebug || console.log('				cmds_startSounds', cmds_startSounds.length, cmds_startSounds);
                    }
                }
                else {
                    if (isButton) {
                        //	sessionID = awayTimeline.potentialPrototypes.length;
                        //	awayTimeline.registerPotentialChild(this.myTestSprite);
                    }
                    //console.log("empty frame");
                }
                if (frameRecipe.length == 0) {
                    command_recipe_flag |= 0x01;
                }
                frameRecipe.push(command_recipe_flag);
            }
        }
        var buttonFrameNames = ['_up', '_over', '_down', '_hit'];
        if (framesLen == 4) {
            var isButtonFrames = 0;
            for (i = 0; i < framesLen; i++) {
                if (swfFrames[i].labelNames
                    && swfFrames[i].labelNames.length > 0
                    && swfFrames[i].labelNames[0] == buttonFrameNames[i]) {
                    isButtonFrames++;
                }
            }
            if (isButtonFrames == 4) {
                isButton = true;
            }
        }
        awayTimeline.numKeyFrames = keyFrameCount;
        awayTimeline.keyframe_durations = new Uint32Array(keyframe_durations);
        awayTimeline.frame_command_indices = new Uint32Array(frameCmdInd);
        awayTimeline.frame_recipe = new Uint32Array(frameRecipe);
        awayTimeline.command_length_stream = new Uint32Array(cmdStreamLength);
        awayTimeline.command_index_stream = new Uint32Array(cmdStremInd);
        awayTimeline.add_child_stream = new Uint32Array(addChildStream);
        awayTimeline.add_sounds_stream = new Uint32Array(addSoundsStream);
        awayTimeline.remove_child_stream = new Uint32Array(remChildStream);
        awayTimeline.update_child_stream = new Uint32Array(updChildStream);
        awayTimeline.update_child_props_indices_stream = new Uint32Array(updСhildStreamPropsInd);
        awayTimeline.update_child_props_length_stream = new Uint32Array(updChildStreamPropsLen);
        awayTimeline.property_type_stream = new Uint32Array(propStreamType);
        awayTimeline.property_index_stream = new Uint32Array(propStreamIndex);
        awayTimeline.properties_stream_int = new Uint32Array(propStreamInt);
        awayTimeline.properties_stream_f32_mtx_scale_rot = new Float32Array(propStramMatrixSR);
        awayTimeline.properties_stream_f32_mtx_pos = new Float32Array(propStreamMatrixPos);
        awayTimeline.properties_stream_f32_mtx_all = new Float32Array(propStreamMatrixAll);
        awayTimeline.properties_stream_f32_ct = new Float32Array(propStreamCT);
        awayTimeline.properties_stream_strings = propStreamStr;
        awayTimeline.properties_stream_filters = propStreamFilters;
        awayTimeline.init();
        if (isButton) {
            // this is a button - set ButtonActions and also get the hitArea from the last frame
            awayMc.buttonMode = true;
            awayTimeline.isButton = true;
            if (buttonActions) {
                awayTimeline.avm1ButtonActions = buttonActions;
            }
            awayTimeline.extractHitArea(awayMc);
        }
        else {
            //a movieclip that isn't a button automatically defaults to mouesEnabled = false
            awayMc.mouseEnabled = false;
        }
        return awayMc;
    };
    return SymbolDecoder;
}());
export { SymbolDecoder };
